import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-total-and-category-progress-bar',
  templateUrl: './total-and-category-progress-bar.component.html',
  styleUrls: ['./total-and-category-progress-bar.component.scss']
})
export class TotalAndCategoryProgressBarComponent implements OnInit {

      @Input() objectives: any []; //Array de objetivos por status y peso

      @Input() item: string = null; //Identificador de cada elemento

      public value1: number = 0;
      public value2: number = 0;
      public value3: number = 0;
      public value4: number = 0;
      public value5: number = 0;

      public segment1;
      public segment2;
      public segment3;
      public segment4;
      public segment5;

  public startProgress() {
    // Elementos de cada segmento de la barra
    this.segment1 = document.getElementById(this.item + '_1');
    this.segment2 = document.getElementById(this.item + '_2');
    this.segment3 = document.getElementById(this.item + '_3');
    this.segment4 = document.getElementById(this.item + '_4');
    this.segment5 = document.getElementById(this.item + '_5');


    // Porcentajes para cada segmento
    let width1 = 0, width2 = 0, width3 = 0 , width4 = 0, width5 = 0;   
   // Intervalos para aumentar el ancho de cada segmento

    //* -------------- AUTHORIZED -------------------
    if (this.value1 > 0 && this.segment1) {
      let interval1 = setInterval(() => {
        if (width1 >= this.value1) {
          clearInterval(interval1); // Detiene cuando llega al valor de value1
        } else {
          width1++;
          this.segment1.style.width = width1 + '%';
        }
      }, 10);
    }
  

    //Todo -------------- CREATED -------------------

    if (this.value2 > 0 && this.segment2) {
      let interval2 = setInterval(() => {
        if (width2 >= this.value2) {
          clearInterval(interval2); // Detiene cuando llega al al valor de value2
        } else {
          width2++;
          this.segment2.style.width = width2 + '%';
        }
      }, 10);
    }
 

    //! --------------REJECTED -------------------
    if (this.value3 > 0 && this.segment3) {
      let interval3 = setInterval(() => {
        if (width3 >= this.value3) {
          clearInterval(interval3); // Detiene cuando llega al al valor de value3
        } else {
          width3++;
          this.segment3.style.width = width3 + '%';
        }
      }, 10); 
    }

    //! --------------INPROGRESS -------------------
    if (this.value4 > 0 && this.segment4) {
      let interval4 = setInterval(() => {
        if (width4 >= this.value4) {
          clearInterval(interval4); // Detiene cuando llega al al valor de value4
        } else {
          width4++;
          this.segment4.style.width = width4 + '%';
        }
      }, 10); 
    }

    // --------------CLOSED-------------------
    if (this.value5 > 0 && this.segment5) {
      let interval5 = setInterval(() => {
        if (width5 >= this.value5) {
          clearInterval(interval5); // Detiene cuando llega al al valor de value5
        } else {
          width5++;
          this.segment5.style.width = width5 + '%';
        }
      }, 10); 
    }
 
  }

  constructor(
    private cdr: ChangeDetectorRef
  ) { }
  
  
  ngOnInit(): void { 
      // Simula el cambio de propiedad después de la inicialización
      setTimeout(() => {
        if (this.objectives.length) {
          this.objectives.forEach(element => {
            element._id == 'CREATED' ? this.value2 = element.weight :
            element._id == 'AUTHORIZED' ? this.value1 = element.weight :
            element._id == 'REJECTED' ? this.value3 = element.weight : ''
            element._id == 'INPROGRESS' ? this.value4 = element.weight : ''
            element._id == 'CLOSED' ? this.value5 = element.weight : ''

          });
        };
    
        this.startProgress();      
      },500);

  }
}